import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import styled, { css } from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { FilterWidget } from '@sorare/core/src/lib/filters';

type Props = {
  widget: FilterWidget;
  activeWidget?: FilterWidget;
  onClick: () => void;
};

const Showable = styled.div<{ show: boolean }>`
  width: 100%;
  ${({ show }) =>
    !show &&
    css`
      display: none !important;
    `}
`;
const Root = styled(Showable)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);

  &:not(.showTitle) {
    padding: 0;
  }

  &:not(:has(.FilterWidget.visible)) {
    display: none;
  }

  padding: var(--double-unit);
`;
const Title = styled(Showable)`
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Content = styled(Vertical)`
  overflow: hidden;
`;

export const MobileFilterWidget = ({
  widget,
  activeWidget,
  onClick,
}: Props) => {
  const defaultOpen = widget.accordionOptions?.startsOpen;
  const showTitle = !activeWidget;
  const isActiveWidget = !!activeWidget && activeWidget.key === widget.key;
  const showComponent = (defaultOpen && showTitle) || isActiveWidget;
  const shouldNavigate = widget.title && showTitle && !showComponent;

  return (
    <Root
      show={showTitle || showComponent}
      className={classNames({ isActiveWidget, showTitle })}
    >
      <Title
        as={shouldNavigate ? 'button' : 'div'}
        type="button"
        onClick={shouldNavigate ? onClick : undefined}
        show={showTitle}
      >
        {widget.title ? (
          <>
            <Content>
              {widget.title || widget.Component({ visible: showComponent })}
            </Content>
            {shouldNavigate && (
              <FontAwesomeIcon
                icon={faChevronRight}
                color="var(--c-neutral-600)"
              />
            )}
          </>
        ) : (
          widget.Component({ visible: showComponent })
        )}
      </Title>
      {widget.title && (
        <Showable show={showComponent}>
          {widget.Component({ visible: showComponent })}
        </Showable>
      )}
    </Root>
  );
};
